/* global femcare */

femcare.navigation.anchor = {

    init: function () {
        var $selectAnchor = $('.sticky-anchor--select');
        var $listAnchor = $('.sticky-anchor--list');
        this.anchorables = $('[data-anchor-index]').toArray();

        if ($selectAnchor.length && this.anchorables.length) {
            femcare.shared.customDropdown.create($selectAnchor[0]);
            $selectAnchor.append('<div class="sticky-anchor__underline"></div>');
            this.initAnchor($selectAnchor, function ($anchor, $activeOption) {
                femcare.shared.customDropdown.setOption($activeOption[0]);
            });
        }

        if ($listAnchor.length && this.anchorables.length) {
            var activeListItemClass = 'active';
            this.initAnchor($listAnchor, function ($anchor, $activeOption) {
                $anchor.find('[data-value]').removeClass(activeListItemClass);
                $activeOption.addClass(activeListItemClass);
            });
        }
    },

    initAnchor: function ($anchor, setActive) {

        for (var i = 0; i < this.anchorables.length; i++) {

            var observer = new IntersectionObserver(function (index, entry) {
                if (entry[0].isIntersecting) {
                    var anchorTarget = this.anchorables[index].getAttribute('data-anchor-index');

                    var $activeElement = $anchor.find('[data-value=' + anchorTarget + ']');

                    if ($activeElement.length) {
                        setActive($anchor, $activeElement);
                        $anchor.find('.select-selected').click();
                    }
                }
            }.bind(this, i),
                {
                    rootMargin: '-50% 0px'
                });

            observer.observe(this.anchorables[i]);
        }

        var animationDuration = 1000;
        $anchor.find('[data-value]').on('click', function (e) {
            var $target = $('[data-anchor-index=' + e.currentTarget.getAttribute('data-value') + ']');
            var position = $target.position();
            var offset = parseInt($anchor.css('top'), 10) + parseInt($anchor.css('height'), 10);
            var targetY = position.top - offset;

            $('html, body').animate({ scrollTop: targetY }, animationDuration);
        }.bind(this));
    }
};